import { useTranslation } from '@rhino-project/core/i18n';
interface StarMeterProps {
  value: number;
  max?: number;
  className?: string;
}

// A 5-star meter that supports fractional fills (values step by 0.5). The
// filled layer is clipped to `value` so half-stars render precisely. Colored
// with the app's dedicated rating token.
const StarMeter = ({ value, max = 5, className }: StarMeterProps) => {
  const { t } = useTranslation();
  return (
    <span
      className={`inline-flex items-center gap-0.5${
        className ? ` ${className}` : ''
      }`}
      aria-label={t('frontend.messages.rating_out_of', { value, max })}
      role="img"
    >
      {Array.from({ length: max }, (_, i) => {
        const fill = Math.max(0, Math.min(1, value - i));
        return (
          <span key={i} className="relative inline-block leading-none">
            <span className="text-rating/25">★</span>
            {fill > 0 && (
              <span
                className="absolute inset-0 overflow-hidden text-rating"
                style={{ width: `${fill * 100}%` }}
              >
                ★
              </span>
            )}
          </span>
        );
      })}
    </span>
  );
};

export default StarMeter;
